module.exports = __webpack_public_path__ + "static/img/230825_BB_PeachMango_Smiley_Anim01_1.7685b3c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/230825_BB_PeachMango_Smiley_Anim01_1.gif
// module id = ccIv
// module chunks = 0